import { Link } from "react-router-dom";
import { Instagram, Phone, Mail } from "lucide-react";
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [workCategories, setWorkCategories] = useState<
    Array<{
      name: string;
      slug: string;
    }>
  >([]);
  useEffect(() => {
    const loadCategories = async () => {
      const { data } = await supabase.from("categories").select("name, slug").order("sort_order");
      if (data) {
        setWorkCategories(data.filter(cat => cat.slug !== "hej-mamma"));
      }
    };
    loadCategories();
  }, []);
  return (
    <footer className="border-t border-border/40 bg-background/70 backdrop-blur-md">
      <div className="container mx-auto px-6 py-12 max-w-5xl">
        <div className="grid grid-cols-2 md:grid-cols-3 gap-8 md:gap-12 md:justify-items-center">
          {/* Contact */}
          <div className="col-span-2 md:col-span-1">
            <h3 className="text-xs uppercase tracking-wider text-muted-foreground mb-4 font-small-heading font-extrabold">
              Contact
            </h3>
            <div className="flex flex-col gap-3">
              <a
                href="mailto:ina.nederdal@gmail.com"
                className="relative inline-flex items-center gap-2 text-sm text-foreground transition-colors font-sans group"
              >
                <Mail size={16} />
                ina.nederdal@gmail.com
                <span className="absolute -bottom-1 left-0 right-0 h-px bg-accent scale-x-0 group-hover:scale-x-100 transition-transform origin-left" />
              </a>
              <a
                href="https://www.instagram.com/inaouti/"
                target="_blank"
                rel="noopener"
                className="relative inline-flex items-center gap-2 text-sm text-foreground transition-colors font-sans group"
              >
                <Instagram size={16} />
                @inaouti
                <span className="absolute -bottom-1 left-0 right-0 h-px bg-accent scale-x-0 group-hover:scale-x-100 transition-transform origin-left" />
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h3 className="text-xs uppercase tracking-wider text-muted-foreground mb-4 font-small-heading font-extrabold">
              Navigation
            </h3>
            <nav className="flex flex-col gap-3">
              <Link to="/" className="relative text-sm text-foreground transition-colors font-sans group inline-block">
                Home
                <span className="absolute -bottom-1 left-0 right-0 h-px bg-accent scale-x-0 group-hover:scale-x-100 transition-transform origin-left" />
              </Link>
              <Link
                to="/hej-mamma"
                className="relative text-sm text-foreground transition-colors font-sans group inline-block"
              >
                Hej Mamma
                <span className="absolute -bottom-1 left-0 right-0 h-px bg-accent scale-x-0 group-hover:scale-x-100 transition-transform origin-left" />
              </Link>
              <Link
                to="/brollopsfotograf"
                className="relative text-sm text-foreground transition-colors font-sans group inline-block"
              >
                Bröllop
                <span className="absolute -bottom-1 left-0 right-0 h-px bg-accent scale-x-0 group-hover:scale-x-100 transition-transform origin-left" />
              </Link>
              <Link
                to="/about"
                className="relative text-sm text-foreground transition-colors font-sans group inline-block"
              >
                About
                <span className="absolute -bottom-1 left-0 right-0 h-px bg-accent scale-x-0 group-hover:scale-x-100 transition-transform origin-left" />
              </Link>
              <Link
                to="/booking"
                className="relative text-sm text-foreground transition-colors font-sans group inline-block"
              >
                Booking
                <span className="absolute -bottom-1 left-0 right-0 h-px bg-accent scale-x-0 group-hover:scale-x-100 transition-transform origin-left" />
              </Link>
            </nav>
          </div>

          {/* Work Categories */}
          <div>
            <h3 className="text-xs uppercase tracking-wider text-muted-foreground mb-4 font-small-heading font-extrabold">
              Work
            </h3>
            <nav className="flex flex-col gap-3">
              {workCategories.map((category) => (
                <Link
                  key={category.slug}
                  to={`/work/${category.slug}`}
                  className="relative text-sm text-foreground transition-colors font-sans group inline-block"
                >
                  {category.name}
                  <span className="absolute -bottom-1 left-0 right-0 h-px bg-accent scale-x-0 group-hover:scale-x-100 transition-transform origin-left" />
                </Link>
              ))}
            </nav>
          </div>
        </div>
        
        {/* Copyright - bottom line */}
        <div className="mt-12 pt-6 border-t border-border/40 text-center">
          <p className="text-sm text-muted-foreground">© {currentYear} Fotograf Ina Nederdal, Stockholm</p>
        </div>
      </div>
    </footer>
  );
};
export default Footer;
